import { Component, Input, Output, EventEmitter, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ControlValueAccessor } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pl-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  standalone: true,
  imports: [FormsModule, CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextboxComponent),
      multi: true,
    },
  ],
})
export class TextboxComponent implements ControlValueAccessor, OnInit {
  @Input() title: string = '';
  @Input() type: string = 'text';
  @Input() required: any = false;
  @Input() show_title: any = true;
  @Input() name: string = '';
  @Input() id: string = '';
  @Input() minlength: string = '';
  @Input() maxlength: string = '';
  @Input() pattern: string = '';
  @Input() readonly: any = false;
  @Input() placeholder: string = '';
  @Input() patternError: string = '';

  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();

  value: any = '';

  // ControlValueAccessor methods
  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;

  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInputChange(event: any) {
    this.value = event;
    this.onChange(this.value);
    this.valueChanged.emit(this.value);
  }

  ngOnInit() {

  }


  get isReadonly(): boolean {
    return this.readonly === true || this.readonly === 'true';
  }

  // Error Handling is moved to the template
}
